import React, { useState, useEffect, useRef } from 'react';
import './Maze.css';

const generateMaze = (rows, cols) => {
  const maze = Array.from({ length: rows }, () => Array(cols).fill(1));
  for (let i = 1; i < rows - 1; i++) {
    for (let j = 1; j < cols - 1; j++) {
      maze[i][j] = Math.random() > 0.7 ? 1 : 0;
    }
  }
  maze[1][1] = 0; // Start point
  maze[rows - 2][cols - 2] = 0; // End point
  return maze;
};

const Maze = () => {
  const [maze, setMaze] = useState([]);
  const [playerPos, setPlayerPos] = useState({ x: 1, y: 1 });
  const [gameOver, setGameOver] = useState(false);
  const gameBoardRef = useRef(null);

  useEffect(() => {
    const newMaze = generateMaze(15, 15);
    setMaze(newMaze);
    setPlayerPos({ x: 1, y: 1 });
    setGameOver(false);
  }, []);

  const handleMove = (direction) => {
    if (gameOver) return;

    let { x, y } = playerPos;
    switch (direction) {
      case 'up':
        if (maze[x - 1][y] === 0) x -= 1;
        break;
      case 'down':
        if (maze[x + 1][y] === 0) x += 1;
        break;
      case 'left':
        if (maze[x][y - 1] === 0) y -= 1;
        break;
      case 'right':
        if (maze[x][y + 1] === 0) y += 1;
        break;
      default:
        break;
    }

    setPlayerPos({ x, y });

    if (x === maze.length - 2 && y === maze[0].length - 2) {
      setGameOver(true);
    }
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      switch (e.key) {
        case 'ArrowUp':
          handleMove('up');
          break;
        case 'ArrowDown':
          handleMove('down');
          break;
        case 'ArrowLeft':
          handleMove('left');
          break;
        case 'ArrowRight':
          handleMove('right');
          break;
        default:
          break;
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [playerPos, gameOver]);

  const startNewGame = () => {
    const newMaze = generateMaze(15, 15);
    setMaze(newMaze);
    setPlayerPos({ x: 1, y: 1 });
    setGameOver(false);
  };

  const changeDifficulty = (difficulty) => {
    let size = 15;
    if (difficulty === 'easy') size = 10;
    if (difficulty === 'hard') size = 20;

    const newMaze = generateMaze(size, size);
    setMaze(newMaze);
    setPlayerPos({ x: 1, y: 1 });
    setGameOver(false);
  };

  return (
    <div className="AppMaze">
      <h1>Maze Game</h1>
      <h2>Player can use arrow keys in the keyboard to move.</h2>
      <div className="controls">
        <button onClick={startNewGame}>Start New Game</button>
        <button onClick={() => changeDifficulty('easy')}>Easy</button>
        <button onClick={() => changeDifficulty('medium')}>Medium</button>
        <button onClick={() => changeDifficulty('hard')}>Hard</button>
      </div>
      <div className="maze" ref={gameBoardRef}>
        {maze.map((row, rowIndex) => (
          <div key={rowIndex} className="rowMaze">
            {row.map((cell, colIndex) => (
              <div key={colIndex} className={`cellMaze ${cell === 1 ? 'wallMaze' : ''} ${cell === 0 && rowIndex === maze.length - 2 && colIndex === maze[0].length - 2 ? 'targetMaze' : ''} ${playerPos.x === rowIndex && playerPos.y === colIndex ? 'playerMaze' : ''}`}></div>
            ))}
          </div>
        ))}
      </div>
      {gameOver && <div className="game-over">You Win!</div>}
      <div className="mobile-controls">
        <button onClick={() => handleMove('up')}>↑</button>
        <button onClick={() => handleMove('down')}>↓</button>
        <button onClick={() => handleMove('left')}>←</button>
        <button onClick={() => handleMove('right')}>→</button>
      </div>
    </div>
  );
};

export default Maze;
